import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { RECOVERY_STORAGE_PREFIX } from './recovery-storage';

export interface CurrentMember {
  memberId?: number;
  token: string;
  studioId?: number;
  studio?: any;
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  private tokenChanged = new Subject<string | null>();
  readonly tokenChanges = this.tokenChanged.asObservable();
  private readonly KEY = 'ngStorage-currentMember';
  private readonly LOGGED_OUT_KEY = 'sfLoggedOut';

  get currentMember(): CurrentMember | null {
    try {
      const raw = sessionStorage.getItem(this.KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  set currentMember(value: CurrentMember | null) {
    if (value) {
      sessionStorage.setItem(this.KEY, JSON.stringify(value));
      sessionStorage.removeItem(this.LOGGED_OUT_KEY);
    } else {
      sessionStorage.removeItem(this.KEY);
    }
    this.tokenChanged.next(value?.token ?? null);
  }

  get hasLoggedOut(): boolean {
    return sessionStorage.getItem(this.LOGGED_OUT_KEY) === '1';
  }

  get token(): string | null {
    return this.currentMember?.token ?? null;
  }

  get isLoggedIn(): boolean {
    return !!this.token;
  }

  get returnToPath(): string | null {
    return sessionStorage.getItem('returnToPath');
  }

  set returnToPath(path: string | null) {
    if (path) {
      sessionStorage.setItem('returnToPath', path);
    } else {
      sessionStorage.removeItem('returnToPath');
    }
  }

  clearSession(): void {
    Object.keys(sessionStorage).forEach(key => {
      if (key !== this.KEY && !key.startsWith(RECOVERY_STORAGE_PREFIX)) sessionStorage.removeItem(key);
    });
  }

  logout(): void {
    this.currentMember = null;
    this.returnToPath = null;
    sessionStorage.setItem(this.LOGGED_OUT_KEY, '1');
  }
}
